// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import DashboardLineTooltip from '../DashboardLineTooltip'
import DashboardPill from '../DashboardPill'
import DashboardTitle from '../DashboardTitle'

// Normalize
import { normalize } from '../../constants'

class DashboardTable extends Component {
  state = {
    option: 0,
    options: [],
    orderBy: '',
    numberOfRows: 5
  }

  componentDidMount() {
    const { variables } = this.props
    let options = []

    variables.map(variable => {
      const { label, value, orderBy } = variable

      options = [...options, { label, value, orderBy }]
    })

    this.setState({
      options,
      orderBy: options[0].orderBy
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { numberOfRows } = this.state
    const { numberOfRows: prevNumberOfRows } = prevState

    if (numberOfRows != prevNumberOfRows) {
      this.scrollToBottom()
    }
  }

  changeOrderBY = (value) => {
    this.setState({ orderBy: value })
  }

  scrollToBottom() {
    this.el.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    const { title, variables, data, to, metric } = this.props
    const { option, options, orderBy, numberOfRows } = this.state
    return (
      <div className="dashboard-table" ref={el => { this.el = el }}>
        <div className="dashboard-table__header">
          <DashboardTitle title={title} subTitle={!_.isEmpty(options) ? options[option].label : ''} metric={metric} />
          {metric &&
            <div className="dashboard-table__metric">
              <div>DIFERENÇA MÉDIA</div>
              <div>{metric.differenceMedian} ({metric.percentageMedian})</div>
            </div>
          }
          {options.length > 1 &&
            <DashboardPill
              option={options[option]}
              options={options}
              onClick={(option, idx) => {
                this.setState({
                  option: idx,
                  orderBy: option.orderBy
                })
              }} />
          }
        </div>
        {!_.isEmpty(data) && !_.isEmpty(options) &&
          <div className="dashboard-table__body">
            <div className="dashboard-table__column">
              <div>
                <span key={variables[option].data[0].value} style={{ color: orderBy === variables[option].data[0].value && "#12B7A3" }} onClick={() => this.setState({ orderBy: variables[option].data[0].value })}>{variables[option].data[0].label}<i className="material-icons">keyboard_arrow_down</i></span>
              </div>
              {_.orderBy(data, [`${options[option].value}[${orderBy}]`, 'name'], [variables[option].data.find(x => x.value === orderBy).order, 'asc'])
                .slice(0, numberOfRows)
                .map((item, idx) => {
                  return (
                    <div key={idx}>
                      <NavLink to={to ? `${to}${item['id']}` : ''}>
                        <span>
                          <p>{normalize(variables[option].data[0].type, item.name)}</p>
                        </span>
                      </NavLink>
                    </div>
                  )
                })
              }
            </div>
            <div className="dashboard-table__column">
              <div>
                {variables[option].data.slice(1).map(variable => (
                  <span key={variable.value} style={{ color: orderBy === variable.value && "#12B7A3" }} onClick={() => this.setState({ orderBy: variable.value })}>{variable.label}<i className="material-icons">keyboard_arrow_down</i></span>
                ))}
              </div>
              {_.orderBy(data, [`${options[option].value}[${orderBy}]`, 'name'], [variables[option].data.find(x => x.value === orderBy).order, 'asc'])
                .slice(0, numberOfRows)
                .map((item, idx) => {
                  return (
                    <div key={idx}>
                      {variables[option].data.slice(1).map(variable => (
                        <NavLink key={variable.value} to={to ? `${to}${item['id']}` : ''}>
                          <span>
                            <p>{normalize(variable.type, item[options[option].value][variable.value])}</p>
                          </span>
                        </NavLink>
                      ))}
                    </div>
                  )
                })}
            </div>
          </div>
        }
        {data.length > 5 &&
          <div className="dashboard-table__more-info" onClick={() => numberOfRows > 5 ? this.setState({ numberOfRows: 5 }) : this.setState({ numberOfRows: data.length })}>{numberOfRows > 5 ? "VER MENOS" : "VER MAIS"}</div>
        }
      </div>
    )
  }

}

export default DashboardTable
